var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.showDialog,"title":_vm.$t('lang.语言设置')},on:{"update:visible":function($event){_vm.showDialog=$event}}},[_c('lang-set',{on:{"save":function($event){_vm.showDialog = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }